// Filigran katmanı — korunan ekranda "kim, ne zaman" izi.
//
// Sağ tık/kopyalama engelleri KAZARA kopyalamayı keser; ekran görüntüsünü
// hiçbir tarayıcı engeli durduramaz. Filigran tam da oraya oynar: görüntü
// alınsa bile üzerinde kimin aldığı yazılı olur. Caydırıcılığı taşıyan parça
// budur, engeller değil.
//
// Metni SUNUCU üretiyor (kullanıcı adı + UTC zaman). İstemcide kurulsaydı
// tarayıcı saatini değiştiren biri izi yanıltabilirdi.

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ContentProtection } from '@/app/core/protection/content-protection';

@Component({
  selector: 'content-watermark',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (protection.watermarkText(); as metin) {
      <div class="mb-watermark" aria-hidden="true">
        @for (i of satirlar; track i) {
          <div class="mb-watermark-row">
            @for (j of sutunlar; track j) {
              <span>{{ metin }}</span>
            }
          </div>
        }
      </div>
    }
  `,
  styles: [
    `
      /* pointer-events: none ŞART — katman tüm ekranı kaplıyor, tıklamayı
         yutsaydı korunan sayfa kullanılamaz hâle gelirdi. */
      .mb-watermark {
        position: fixed;
        inset: 0;
        z-index: 2147483000;
        pointer-events: none;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        user-select: none;
      }

      .mb-watermark-row {
        display: flex;
        justify-content: space-around;
        transform: rotate(-24deg);
        white-space: nowrap;
      }

      .mb-watermark-row span {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.04em;
        color: rgb(15 23 42 / 7%);
      }

      :host-context(.dark) .mb-watermark-row span {
        color: rgb(248 250 252 / 9%);
      }

      @media print {
        /* Yazdırmada daha koyu: kâğıda düşen kopyada iz okunabilir kalmalı. */
        .mb-watermark-row span {
          color: rgb(15 23 42 / 22%);
        }
      }
    `,
  ],
})
export class ContentWatermark {
  protected readonly protection = inject(ContentProtection);

  // Sabit ızgara: metin uzunluğuna göre hesaplamak ekran boyutu her
  // değiştiğinde yeniden ölçüm isterdi; 6×4 her yaygın en-boy oranında kaplıyor.
  protected readonly satirlar = [0, 1, 2, 3, 4, 5];
  protected readonly sutunlar = [0, 1, 2, 3];
}
